<template>
  <div class="roles">
    <modal :title="title" v-if="modal" @close="switchModal">
      <role @close="switchModal" :data="editableRole"/>
    </modal>
    <ccs-header
      :title="'Роли'"
      :info="false" nightTheme back/>
    <div class="roles-content">
      <div class="roles-actions">
        <nav-bar :dataFunction="getRoles" :orderFields="orderFields" nightTheme/>
        <button v-if="permissionsStatus.isRoleCreateAllowed"
          class="ccs-button" @click="switchModal">
          Добавить роль
        </button>
      </div>
      <ccs-table :data="roles" :columnsDefs="columnsDefs" :options="tableOptions"
        :defaultActions="defaultActions" @edit="startEditing" @delete="removeRole"/>
      <pagination :dataFunction="getRoles" nightTheme/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';
import NavBar from '@/components/NavBar.vue';
import Pagination from '@/components/Pagination.vue';

import Role from '@/components/modals/roles/Role.vue';

export default {
  name: 'Roles',
  components: {
    'ccs-header': Header,
    'ccs-table': Table,
    Modal,
    Role,
    NavBar,
    Pagination,
  },
  data() {
    return {
      modal: false,
      editableRole: null,
      titles: {
        new: 'Новая роль',
        edit: 'Редактирование роли',
      },
      orderFields: [{
        prop: 'id',
        text: 'Дате создания',
      }, {
        prop: 'name',
        text: 'Названию',
      }, {
        prop: 'slug',
        text: 'Обозначению',
      }],
      columnsDefs: [
        {
          name: `name`,
          title: 'Название',
          prop: 'name',
          type: 'text',
        },
        {
          name: `slug`,
          title: `Обозначение`,
          prop: `slug`,
          type: 'text',
        },
      ],
      tableOptions: {
        hideBottomBorder: true,
        nightTheme: true,
      },
    };
  },
  computed: {
    ...mapState('users', ['roles']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editableRole ? this.titles.edit : this.titles.new;
    },
    defaultActions() {
      return {
        edit: this.permissionsStatus.isRoleUpdateAllowed,
        delete: this.permissionsStatus.isRoleDeleteAllowed,
      };
    },
  },
  methods: {
    ...mapActions('users', ['getRoles', 'updateRole', 'deleteRole']),
    switchModal() {
      this.modal = !this.modal;
      if (this.editableRole) {
        this.editableRole = null;
      }
    },
    startEditing(role) {
      this.switchModal();
      this.editableRole = Object.assign({}, role);
    },
    async removeRole(role) {
      try {
        await this.deleteRole(role.id);
        this.$toasted.success('Роль удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.roles {
  min-height: 100%;
  min-width: 100%;
  background: $surfaceDarker;

  &-content {
    margin: 0 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  &-actions {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

}
</style>
